export enum EvalFilters {
  Upcoming = 'Upcoming',
  Ongoing = 'Ongoing',
  PendingToClose = 'Pending to close',
  PendingToStart = 'Pending to start',
}
